import Icon from 'veui/components/Icon'
import { IconCheckSquareSolid } from 'dls-icons-vue'

Icon.register('check-square-solid', IconCheckSquareSolid)
